import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import { getReadOnly } from '../../../../lib/ReduxFormSelectors/ProposalListingForm'

const readOnlySelector = createSelector(
  [getReadOnly],
  readOnly => readOnly
)

const mapStateToProps = state => {
  return ({
    readOnly: readOnlySelector(state)
  })
}

function withProposalListingFormReadOnly (MainComponent) {
  return connect(mapStateToProps)(MainComponent)
}

export default withProposalListingFormReadOnly
